<template>
  <div class="container page">
    <van-nav-bar :title="$t('mine.gamerecord')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="game-record-card" v-for="item in list" :key="item.id">
          <div class="gr-header">
            <span class="gr-id">{{ item.expect }}</span>
            <span class="gr-name">{{ item.name }}</span>
          </div>
          <div class="gr-result" v-if="hasOpenCode(item)">
            <span class="gr-result-label">{{ getResultText(item.opencode) }}</span>
          </div>
          <div class="gr-status-row">
            <span class="gr-status" :class="{ pending: item.status !== 1 }">{{ getTaskStatus(item) }}</span>
            <span class="gr-amount">{{ $t('game_record.bet_amount') }}: {{ formatBetMoney(item.money) }}</span>
          </div>
          <div class="gr-bet-row" v-if="getBetContent(item)">
            <span class="gr-bet-label">{{ $t('game_record.bet_content') }}:</span>
            <span class="gr-bet-value">{{ getBetContent(item) }}</span>
          </div>
          <div class="gr-time">{{ $t('reservation.order_time') }}: {{ item.create_time }}</div>
          <div class="gr-time">{{ $t('reservation.settle_time') }}: {{ item.update_time }}</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getBetContent, formatBetMoney } from '@/utils/gameBet'

export default {
  data() {
    return {
      isLoading: false,
      list: []
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    onRefresh() {
      this.getUserGameList()
    },
    getUserGameList() {
      this.isLoading = true
      this.$http({ method: 'get', url: 'user_get_game_list' }).then(res => {
        this.isLoading = false
        if (res.code === 200) {
          const raw = res.data || []
          this.list = Array.isArray(raw) ? raw : Object.values(raw)
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    normalizeOpenCode(raw) {
      if (raw == null || raw === '') return null
      let arr = raw
      if (typeof raw === 'string') {
        arr = raw.split(/[,|，\s]+/).filter((v) => v !== '')
      }
      if (!Array.isArray(arr) || arr.length < 3) return null
      const codes = [parseInt(arr[0], 10), parseInt(arr[1], 10), parseInt(arr[2], 10)]
      if (codes.some((n) => Number.isNaN(n))) return null
      return codes
    },
    hasOpenCode(item) {
      return !!this.normalizeOpenCode(item && item.opencode)
    },
    getSum(opencode) {
      const codes = this.normalizeOpenCode(opencode)
      if (!codes) return 0
      return codes[0] + codes[1] + codes[2]
    },
    /** 与游戏页一致：只显示 Modell / Schwester + Sekretär / Schüler */
    getResultText(opencode) {
      const sum = this.getSum(opencode)
      if (!sum) return ''
      const sizeWord = sum >= 11 && sum <= 18 ? 'Modell' : 'Schwester'
      const doubleWord = sum % 2 === 0 ? 'Schüler' : 'Sekretär'
      return `${sizeWord} ${doubleWord}`
    },
    getBetContent,
    formatBetMoney,
    getTaskStatus(item) {
      if (item.status === 1) return this.$t('game_record.status_completed')
      return item.status_text || this.$t('my.audit_waiting')
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.gr-result {
  margin: 8px 0 4px;
}

.gr-result-label {
  font-size: 28px;
  font-weight: 700;
  color: #ff7186;
  line-height: 1.3;
}

.gr-bet-value {
  color: #ff253f;
  font-weight: 600;
}
</style>
